import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useStatus, SUCCESS, ERROR } from '@rootstrap/redux-tools';

import useToast from 'hooks/useToast';
import useAnalytics from 'hooks/useAnalytics';
import { MIXPANEL_EVENTS } from 'constants/constants';
import { replaceError } from 'utils/helpers';
import { reportPodcast } from 'state/actions/podcastActions';

export default () => {
  const dispatch = useDispatch();
  const { trackEvent } = useAnalytics();
  const { status, error } = useStatus(reportPodcast);

  const { showErrorToast, showToast } = useToast();

  useEffect(() => {
    if (status === SUCCESS) {
      trackEvent(MIXPANEL_EVENTS.reportPodcast);
      showToast('The content was successfully reported!');
      dispatch(reportPodcast.reset());
    }
    if (status === ERROR) {
      showErrorToast(replaceError(error, /^reason /));
      dispatch(reportPodcast.reset());
    }
  }, [dispatch, showErrorToast, showToast, status, error]);

  return useCallback(({ podcastId, params }) => dispatch(reportPodcast({ podcastId, params })), [
    dispatch
  ]);
};
